import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronRight, FiHome } = FiIcons;

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  
  // Map of path to display name
  const pathDisplayNames = {
    'agencies': 'Agencies',
    'articles': 'Articles',
    'domains': 'Domains',
    'earnings': 'Earnings',
    'analytics': 'Analytics',
    'settings': 'Settings'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-center text-sm text-gray-500 mb-4"
    >
      <Link to="/" className="flex items-center hover:text-primary-600 transition-colors">
        <SafeIcon icon={FiHome} className="w-4 h-4 mr-1" />
        <span>Home</span>
      </Link>
      
      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const displayName = pathDisplayNames[name] || name;
        
        return (
          <React.Fragment key={routeTo}>
            <SafeIcon icon={FiChevronRight} className="mx-2 w-3 h-3" />
            {isLast ? (
              <span className="font-medium text-gray-700">{displayName}</span>
            ) : (
              <Link to={routeTo} className="hover:text-primary-600 transition-colors">
                {displayName}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </motion.div>
  );
};

export default Breadcrumbs;